"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useRef } from "react";
import NavItem from "./NavItem";
import type { NavItem as NavItemData } from "./navTypes";
import HomeIcon from "../common/icons/HomeIcon";
import WavesIcon from "../common/icons/WavesIcon";
import ChatBubbleIcon from "../common/icons/ChatBubbleIcon";
import Squares2X2Icon from "../common/icons/Squares2X2Icon";
import BellIcon from "../common/icons/BellIcon";
import UsersIcon from "../common/icons/UsersIcon";
import LogoIcon from "../common/icons/LogoIcon";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import useCapacitor from "@/hooks/useCapacitor";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getNotificationsRoute } from "@/helpers/navigation.helpers";
const items: NavItemData[] = [{
  kind: "route",
  name: "Home",
  href: "/",
  icon: "home",
  iconComponent: HomeIcon
}, {
  kind: "view",
  name: "Waves",
  viewKey: "waves",
  icon: "waves",
  iconComponent: WavesIcon,
  iconSizeClass: "tw-size-6"
}, {
  kind: "view",
  name: "Messages",
  viewKey: "messages",
  icon: "messages",
  iconComponent: ChatBubbleIcon
}, {
  kind: "route",
  name: "Stream",
  href: "/",
  icon: "stream",
  iconComponent: LogoIcon,
  iconSizeClass: "tw-size-9"
}, {
  kind: "route",
  name: "Network",
  href: "/network",
  icon: "network",
  iconComponent: UsersIcon
}, {
  kind: "route",
  name: "Collections",
  href: "/the-memes",
  icon: "collections",
  iconComponent: Squares2X2Icon
}, {
  kind: "route",
  name: "Notifications",
  href: "/notifications",
  icon: "notifications",
  iconComponent: BellIcon
}];
const BottomNavigation: React.FC = () => {
  const $ = _c(12);
  const {
    registerRef
  } = useLayout();
  const {
    isAndroid
  } = useCapacitor();
  const {
    isApp
  } = useDeviceInfo();
  const mobileNavRef = useRef(null);
  let t0;
  if ($[0] !== registerRef) {
    t0 = node => {
      mobileNavRef.current = node;
      registerRef("mobileNav", node);
    };
    $[0] = registerRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setMobileNavRef = t0;
  let t1;
  if ($[2] !== isApp) {
    t1 = items.map(item => item.name === "Notifications" ? {
      ...item,
      href: getNotificationsRoute(isApp)
    } : item);
    $[2] = isApp;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const navItems = t1;
  const paddingClass = isAndroid ? "tw-pb-[env(safe-area-inset-bottom,0px)]" : "";
  const t2 = `${paddingClass} tw-fixed tw-left-0 tw-w-full tw-bottom-0 tw-bg-black tw-border-t tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-iron-900 tw-shadow-inner tw-z-50`;
  let t3;
  if ($[4] !== navItems) {
    t3 = navItems.map(_temp);
    $[4] = navItems;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="tw-h-full"><ul className={"tw-flex tw-h-full tw-pl-[env(safe-area-inset-left,0px)]\n    tw-pr-[env(safe-area-inset-right,0px)] md:tw-max-w-2xl tw-mx-auto"}>{t3}</ul></div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== setMobileNavRef || $[9] !== t2 || $[10] !== t4) {
    t5 = <nav ref={setMobileNavRef} className={t2}>{t4}</nav>;
    $[8] = setMobileNavRef;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default BottomNavigation;
function _temp(item_0) {
  return <li key={item_0.name} className={`tw-flex tw-flex-1 tw-justify-center tw-items-end ${item_0.name === "Stream" ? "-tw-translate-y-1" : ""} tw-h-full tw-min-w-0`}><NavItem item={item_0} /></li>;
}